import React, {useState} from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// import App from './App';



function App(){
  const [fruit,setFruit] = useState('orange') 
  const [puppyImage,setPuppyImage] = useState('')
  const onclickfn = () =>{
    fruit ==="orange" ? setFruit('Bananas') : setFruit('orange')
  }
  const  onclickfn2 = async () =>{
    setPuppyImage('loading...')
    let dog_response =  await fetch('https://dog.ceo/api/breeds/image/random').then()
    let dog_json = await dog_response.json()
    let dog = {name:"my puppy",age:4,image: dog_json.message}
    setPuppyImage(dog.image)
    setFruit(dog.name)
  }
  return (
    <>
      <h1>I like {fruit}</h1>
      <button onClick={ onclickfn } >change Fruit</button>
      <button onClick={ onclickfn2 } >change Fruit from api</button>
      <br/>
      { puppyImage!==''? <img height="200px"  alt="loading puppy.." src={puppyImage} /> : <h1>no image</h1> }
    </>
  )
}

ReactDOM.render(
  <App/>,
  document.getElementById('root')
)